import { createAsyncThunk } from "@reduxjs/toolkit";
import { retrieveStudioId } from "../../../utils/storage";

export const doUploadImgNews = createAsyncThunk(
  "uploadImgNews/upload",
  async ({ url, file, type, thunkAPI }) => {
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": type,
        'X-SelectedAdminStudio': `${retrieveStudioId()}`
      },
      body: file,
    });

    if (response.ok) {
      return thunkAPI.fulfillWithValue(response.data);
    } else {
      return thunkAPI.rejectWithValue();
    }
  }
);

